import {Component, inject, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {VuiHeader} from '@viessmann/ui/header';
import {VuiFooter} from '@viessmann/ui/footer';
import {SearchPage} from './search/page/search-page';
import {SchemePage} from './scheme/page/scheme-page';
import {SearchFacade} from './search/application/search.facade';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, VuiHeader, VuiFooter, SearchPage, SchemePage],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('schematic-browser-frontend');

  private readonly _searchFacade = inject(SearchFacade);

  protected onSearchQuery(query: string): void {
    this._searchFacade.searchByQuery(query || null);
  }
}
